export const containsUrlRegex =
  /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?/g

// use the same regex but the string needs to end with the url
export const urlRegex = new RegExp(`${containsUrlRegex.source}$`, containsUrlRegex.flags)
